module.exports = __webpack_public_path__ + "static/img/tabela.e0ccae2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/refricola/tabela.png
// module id = w6KM
// module chunks = 0